export const translations = {
  nl: {
    nav: {
      home: "Home",
      bowling: "Bowling",
      arrangements: "Arrangementen",
      kids: "Kinderfeestjes",
      restaurant: "Restaurant",
      jenever: "Jenever Discobowling",
      contact: "Contact",
      faq: "FAQ",
      book: "Reserveer nu",
    },
    hero: {
      eyebrow: "Entertainment Center · Restaurant · Bar",
      title1: "Bowling",
      title2: "Helios",
      tagline: "Because it's more fun to bowl a strike!",
      sub: "Bowlen, disco, lekker eten & gezelligheid in Balen.",
      cta1: "Reserveer nu",
      cta2: "Bekijk onze arrangementen",
      scroll: "Scroll",
    },
    quick: {
      title: "Alles onder één dak",
      sub: "Een avondje Helios is meer dan enkel bowlen.",
      lanes: "8 bowlingbanen",
      lanesText: "Automatische banen, met bumpers voor de kleintjes.",
      pool: "Pool",
      poolText: "Daag je vrienden uit aan de pooltafel.",
      darts: "Darts",
      dartsText: "Gooi je scherpste pijlen tussen de games door.",
      food: "Ruime eetgelegenheid",
      foodText: "Restaurant met een uitgebreide kaart voor iedereen.",
      cocktail: "Cocktailbar",
      cocktailText: "Frisse cocktails en lekkere pintjes aan de bar.",
    },
    manifesto: {
      eyebrow: "De Helios ervaring",
      c1t: "Bowlen",
      c1x: "Acht gloednieuwe automatische banen, sfeervolle verlichting en die ene perfecte strike. Voor families, koppels en vriendengroepen.",
      c2t: "Arrangementen",
      c2x: "Eten + bowlen = de perfecte combinatie. Van oervlaams stoofvlees tot steengrill, altijd met twee games inbegrepen.",
      c3t: "Bowl & Brunch",
      c3x: "Eerst brunchen. Daarna bowlen. Of andersom. Onze nieuwe weekendformule met brunchbuffet en twee games.",
      c4t: "(Jenever) Discobowling",
      c4x: "Lichtshow, blacklight en de beste hits. De banen veranderen in een dancefloor — gooien maar.",
      c5t: "Pool",
      c5x: "Daag je vrienden uit aan onze pooltafels — de perfecte afwisseling tussen twee games.",
      c6t: "Darts",
      c6x: "Onze dartborden wachten op je scherpste pijlen, voor beginners en competitiespelers.",
      c7t: "Cocktailbar",
      c7x: "Sluit je avond af aan de bar met een frisse cocktail of een lekker biertje.",
      c8t: "Kinder Discobowling",
      c8x: "Discobowling voor de kleintjes: elke woensdag en zaterdag vóór 20:00.",
      c9t: "Kinderfeestjes",
      c9x: "Spetterende verjaardagsfeestjes met bowlen, frietjes en een cadeautje voor de jarige.",
      link: "Ontdek meer",
    },
    prices: {
      title: "Bowling tarieven",
      sub: "Eerlijk en duidelijk: alle prijzen zijn per persoon, per game.",
      perPerson: "per persoon",
      perGame: "per game",
      r1: "Maandag – donderdag vóór 18u",
      r2: "Maandag – donderdag vanaf 18u",
      r3: "Vrijdag, zaterdag, zondag & feestdagen",
      r4: "Discobowling",
      r5: "Jenever Discobowling",
      r6: "Schoolvakanties maandag – vrijdag",
      r7: "Bowling schoenen",
      note: "Prijzen zijn per persoon, per game. Een game is één bowlingronde.",
      cta: "Reserveer een baan",
      poolDartsTitle: "Pool & Darts tarieven",
      poolDartsNote: "Pool en darts zijn per tafel of per blok — niet per persoon.",
      poolGreen: "Pool · groene tafel",
      poolGreenMeta: "per uur · optelsysteem · per tafel",
      poolRed: "Pool · rode tafel",
      poolRedMeta: "per spel · muntjes · per tafel",
      dartsRow: "Darts",
      dartsMeta: "per blok · per uur",
    },
    disco: {
      title: "Disco Bowling",
      sub: "Lichtshow, blacklight & de beste hits",
      text: "Als de zon ondergaat, verandert Helios in een neonparadijs. Discoballen, kleurrijke lichtstralen en muziek die je meeneemt — bowlen werd nog nooit zo feestelijk.",
      price: "€5,50",
      cta: "Reserveer discobowling",
    },
    arrangements: {
      title: "Arrangementen",
      sub: "Eten + bowlen = de perfecte combinatie.",
      banner: "Prijzen = per persoon",
      includes: "Inbegrepen",
      perPerson: "per persoon",
      min8: "Minimum 8 personen",
      allin: "All-in optie",
      allinText: "Dranken gedurende 4 uur inbegrepen, met uitzondering van sterke dranken en energiedranken.",
      depositTitle: "Annulatievoorwaarden",
      depositText: "Er wordt geen voorschot gevraagd. Bij annulatie minder dan 48 uur vooraf wordt €10 per persoon aangerekend.",
      cta: "Reserveer arrangement",
      a1: { name: "Vlaams", tag: "De klassieker", items: ["Aperitief van het huis", "Soep", "Groentenassortiment", "Vidée of stoofvlees", "Frieten", "Dessert van het huis", "2 bowlinggames", "Schoenen inbegrepen"] },
      a2: { name: "Italiaans", tag: "Pasta perfetta", items: ["Aperitief van het huis", "Lookbroodje", "Spaghetti bolognaise, carbonara of vegetarische pasta", "Dessert van het huis", "2 bowlinggames", "Schoenen inbegrepen"] },
      a3: { name: "Koud Buffet", tag: "Voor groepen", items: ["Aperitief van het huis", "Koud buffet", "Dessert van het huis", "2 bowlinggames", "Schoenen inbegrepen"] },
      a4: { name: "Steengrill", tag: "Gloeiend heet", items: ["Aperitief van het huis", "Steengrill met mix van vlees en vis", "Groentenmix", "Pasta & aardappelsalade", "Frieten & stokbrood", "Diverse sauzen", "Dessert van het huis", "2 bowlinggames", "Schoenen inbegrepen"] },
    },
    brunch: {
      title: "Bowl & Brunch",
      concept: "Eerst brunchen. Daarna bowlen. Of andersom.",
      text: "Onze nieuwste formule: een stijlvolle brunch onder de discobal, gevolgd door twee games op de banen. Weekendvibes gegarandeerd.",
      included: "Inbegrepen",
      perPerson: "per persoon",
      kids02: "Kinderen 0–2 jaar: gratis",
      kids35: "Kinderen 3–5 jaar: €10 per kind",
      cta: "Reserveer Bowl & Brunch",
      badge: "Nieuw",
    },
    kids: {
      title: "Kinderfeestjes",
      sub: "Een spetterend verjaardagsfeestje op de banen.",
      price: "€17,50",
      perKid: "per kind",
      minKids: "Vanaf 6 kinderen",
      included: "Inbegrepen",
      items: ["2 bowlingspelletjes", "Huur schoenen", "1 drankje", "1 ijsje per kind", "Leuke attentie en geschenk voor de jarige"],
      formulas: "Formules",
      formulaItems: ["Frietjes met curryworst, kaaskroket of slaatje", "Spaghetti bolognaise", "Broodje curryworst of hamburger", "Pannenkoeken", "Frikadellen met krieken", "Pizza margherita, kip BBQ of pepperoni (halve pizza per kind)"],
      extra: "Extra bowlinggame",
      extraPrice: "€2,50 per game",
      discoNote: "Kinderdiscobowling: elke woensdag en zaterdag vóór 20:00.",
      cta: "Boek een feestje",
    },
    restaurant: {
      title: "Meer dan bowlen",
      sub: "Ons restaurant & café",
      text: "Is bowlen niks voor jou? Dan nog ben je bij ons van harte welkom! In ons restaurant geniet je van een lekker drankje en een heerlijke maaltijd. Op onze uitgebreide kaart vind je vast iets waar je zin in hebt.",
      menu: "Bekijk menukaart",
      drinks: "Bekijk drankenkaart",
    },
    jenever: {
      title: "Jenever Discobowling",
      sub: "De legendarische Helios-traditie",
      text: "Bowlen, disco en een vleugje jenever-gezelligheid. De perfecte avond uit met vrienden: strikes, sfeer en de beste classics door de speakers — en je kan jenever shots of andere leuke prijzen winnen!",
      price: "€5,50",
      note: "Elke zaterdag vanaf 20:00. Op vrijdag is er buiten de competitie om de 2 weken discobowling of thema-bowling.",
      themeTitle: "Thema-bowling op vrijdag",
      themeText: "Om de week is er op vrijdag thema-bowling. Wil je weten welk thema eraan komt? Bel ons even of kijk op onze Instagram!",
      themeCall: "Bel 014 81 20 93",
      themeInsta: "Instagram",
      cta: "Reserveer jenever discobowling",
    },
    reviews: {
      title: "Wat zeggen onze bowlers?",
      viaGoogle: "Reviews via Google",
      allOnMaps: "Bekijk alle reviews op Google Maps",
      items: [
        { text: "Geweldig kinderfeestje met 8 kinderen. Bowling, pool, frietjes gegeten. Zeer leuke namiddag! Bedankt Bowling Helios!", author: "Marie uit Mol-Wezel" },
        { text: "Al jaren onze vertrouwde bowling. Mooie banen en alles tip-top geregeld voor een avondje bowling!", author: "Steven uit Balen" },
        { text: "Top locatie om te komen bowlen. Met onze oudleiding geweldig geamuseerd met een discobowling. Tot de volgende keer!", author: "Matthias uit Meerhout" },
      ],
    },
    hours: {
      title: "Openingsuren",
      mon: "Maandag",
      tue: "Dinsdag",
      wed: "Woensdag",
      thu: "Donderdag",
      fri: "Vrijdag",
      sat: "Zaterdag",
      sun: "Zondag",
      closed: "Gesloten",
      groups: "Verenigingen en scholen kunnen ook buiten de normale openingsuren reserveren.",
      holidays: "Tijdens schoolvakanties zijn we elke dag open — ook op maandag, van 11:00 tot 23:00 (of tot sluiting als het wat uitloopt). Op feestdagen die op een maandag vallen zijn we open vanaf 11:00 tot sluiting.",
    },
    contact: {
      title: "Contact",
      sub: "Tot ziens in Balen",
      address: "Gerheide 48, 2490 Balen, België",
      call: "Bel ons",
      mail: "Mail ons",
      route: "Route plannen",
    },
    reserve: {
      title: "Reserveer nu",
      sub: "Vul het formulier in en wij bevestigen je boeking zo snel mogelijk.",
      name: "Naam",
      email: "E-mail",
      phone: "Telefoon",
      people: "Aantal personen",
      date: "Datum",
      time: "Startuur (ongeveer)",
      type: "Type reservatie",
      arrangement: "Arrangement",
      message: "Extra informatie",
      types: { bowling: "Bowling", discobowling: "Discobowling", jenever: "Jenever Discobowling", arrangement: "Arrangement", kinderfeestje: "Kinderfeestje", other: "Anders" },
      arrOptions: { vlaams: "Vlaams — €43 p.p.", italiaans: "Italiaans — €43 p.p.", "koud-buffet": "Koud Buffet — €52 p.p.", steengrill: "Steengrill — €52 p.p." },
      formula: "Formule",
      formulaOptions: { frietjes: "Frietjes met curryworst, kaaskroket of slaatje", spaghetti: "Spaghetti bolognaise", broodje: "Broodje curryworst of hamburger", pannenkoeken: "Pannenkoeken", frikadellen: "Frikadellen met krieken", pizza: "Pizza margherita, kip BBQ of pepperoni (halve pizza per kind)" },
      arrWarning: "Let op: arrangementen zijn geprijsd per persoon.",
      deposit: "Er wordt geen voorschot gevraagd. Bij annulatie minder dan 48 uur vooraf wordt €10 per persoon aangerekend.",
      submit: "Verstuur reservatie",
      sending: "Versturen...",
      successTitle: "Reservatie ontvangen!",
      successText: "Bedankt! We hebben je aanvraag goed ontvangen en bevestigen je boeking zo snel mogelijk per e-mail of telefoon.",
      again: "Nieuwe reservatie",
      error: "Er ging iets mis. Probeer opnieuw of bel ons op +32 (0)14 81 20 93.",
      emailError: "Controleer je e-mailadres — er lijkt een typfout in te staan.",
      netError: "Geen antwoord van de server. Je reservatie kan toch aangekomen zijn — check je mailbox of bel ons even: +32 (0)14 81 20 93.",
      discoWarn1: "Jenever Discobowling start elke zaterdag om 20:00. Op vrijdag is er om de week ",
      discoWarnLink: "discobowling of thema-bowling",
      discoWarn2: " — bel ons even of kijk op Instagram om te weten welk thema eraan komt.",
      timeError: "Kies een rond halfuur, bijvoorbeeld 15:00 of 15:30.",
      fridayNewsTitle: "Thema-bowling op vrijdag",
      fridayNewsSub: "Om de week op vrijdag — bel ons of kijk op Instagram voor het thema",
      fridayNewsFrom: "vanaf 20:00",
      fridayNewsCta: "Bekijk onze Instagram",
    },
    xmas: {
      title: "Samen aftellen tot Sinterklaas en Kerstmis!",
      sub: "De feestdagen vieren we samen — met sneeuw, lichtjes en strikes!",
      days: "dagen",
      hours: "uur",
      minutes: "minuten",
      seconds: "seconden",
      toSint: "tot Sinterklaas!",
      toXmas: "tot Kerstmis!",
      merry: "Fijne feestdagen!",
    },
    insta: {
      title: "Volg ons op Instagram",
      sub: "Thema-avonden, sfeer en acties — als eerste op Instagram",
      follow: "Naar @bowlinghelios",
    },
    footer: {
      tagline: "Because it's more fun to bowl a strike!",
      links: "Snel naar",
      contactTitle: "Contact",
      hoursTitle: "Openingsuren",
      rights: "Alle rechten voorbehouden.",
    },
    marquee: "Disco Bowling · Arrangementen · Kinderfeestjes · Jenever Discobowling · Restaurant · ",
    faq: {
      title: "Veelgestelde vragen",
      sub: "Alles wat je wil weten over bowlen, eten, reserveren en meer.",
      search: "Zoek in de FAQ...",
      all: "Alles",
      noResults: "Geen vragen gevonden. Probeer een andere zoekterm of categorie.",
      stillTitle: "Geen antwoord gevonden?",
      stillText: "Staat jouw vraag er niet tussen? Geen probleem! Neem gerust contact met ons op — we helpen je graag verder en beantwoorden je vraag zo snel mogelijk.",
      stillSocial: "Of stuur ons een bericht via Facebook of Instagram. Tot snel bij Bowling Helios!",
    },
    news: {
      title: "Nieuws",
      sub: "Het laatste van Bowling Helios",
      n1tag: "Vernieuwd",
      n1t: "Onze bowling is helemaal vernieuwd!",
      n1d: "14 – 22 september 2026",
      n1x: "Een week lang werd er hard gewerkt: van 14 tot 22 september 2026 kreeg onze bowling een complete make-over. Nieuwe ballen, nieuwe schoenen, nieuwe machines, nieuwe displays en nieuwe balreturns — alles straalt weer als nooit tevoren.",
      n2tag: "Nieuw",
      n2t: "Stairway to Heaven — onze vernieuwde cocktailbar",
      n2d: "September 2026",
      n2x: "Onder de trap vind je voortaan Stairway to Heaven: onze vernieuwde cocktailbar, in dezelfde week helemaal opgefrist. Ontdek een nog grotere cocktail- en speciaaldrankenkaart dan op de menukaart staat. Kom proeven!",
    },
    admin: {
      title: "Helios Admin",
      login: "Inloggen",
      password: "Wachtwoord",
      logout: "Uitloggen",
      brunchSettings: "Bowl & Brunch instellingen",
      priceAdult: "Prijs volwassene (€)",
      priceKid: "Prijs kind 3–5 jaar (€)",
      menuNl: "Menu items (NL — één per lijn)",
      menuEn: "Menu items (EN — één per lijn)",
      save: "Opslaan",
      saved: "Opgeslagen!",
      reservations: "Reservaties",
      noReservations: "Nog geen reservaties.",
      loginError: "Ongeldige login.",
      confirm: "Bevestig",
      confirmSend: "Verstuur bevestiging",
      confirmed: "Bevestigd",
      notePlaceholder: "Optioneel bericht voor de klant (bv. baan 5 gereserveerd)",
      cancel: "Annuleer",
      cancelSend: "Verstuur annulatie",
      cancelled: "Geannuleerd",
      reasonPlaceholder: "Reden van annulatie (wordt naar de klant gemaild)",
      reopen: "Herstel",
      delete: "Verwijder",
      deleteConfirm: "Zeker?",
      templates: "Kant-en-klare berichten",
      templatesHint: "Klik op kopieer en plak het bericht in je mail of gesprek.",
      copy: "Kopieer",
      copied: "Gekopieerd!",
      tpl1Name: "Bevestiging",
      tpl2Name: "Banen volzet",
      tpl1: "Bij deze is uw reservatie bevestigd. Heeft u nog vragen? Stuur gerust een mail naar heliosbowling@gmail.com of bel 014 81 20 93 met vermelding van de naam van uw reservatie. We kijken ernaar uit u te verwelkomen!",
      tpl2: "Spijtig genoeg zijn alle banen bezet op deze datum. Bel ons gerust op 014 81 20 93, dan zoeken we samen een ander geschikt moment.",
      customTitle: "Eigen berichten",
      quickFill: "Vul snel in",
      addTemplate: "Bericht toevoegen",
      tplName: "Naam van het bericht",
      tplText: "Berichttekst",
    },
  },
  en: {
    nav: {
      home: "Home",
      bowling: "Bowling",
      arrangements: "Packages",
      kids: "Kids' Parties",
      restaurant: "Restaurant",
      jenever: "Jenever Disco Bowling",
      contact: "Contact",
      faq: "FAQ",
      book: "Book now",
    },
    hero: {
      eyebrow: "Entertainment Center · Restaurant · Bar",
      title1: "Bowling",
      title2: "Helios",
      tagline: "Because it's more fun to bowl a strike!",
      sub: "Bowling, disco, great food & good vibes in Balen.",
      cta1: "Book now",
      cta2: "View our packages",
      scroll: "Scroll",
    },
    quick: {
      title: "Everything under one roof",
      sub: "A night at Helios is more than just bowling.",
      lanes: "8 bowling lanes",
      lanesText: "Automatic lanes, with bumpers for the little ones.",
      pool: "Pool",
      poolText: "Challenge your friends at the pool table.",
      darts: "Darts",
      dartsText: "Throw your sharpest darts between games.",
      food: "Spacious dining",
      foodText: "A restaurant with an extensive menu for everyone.",
      cocktail: "Cocktail bar",
      cocktailText: "Fresh cocktails and tasty beers at the bar.",
    },
    manifesto: {
      eyebrow: "The Helios experience",
      c1t: "Bowling",
      c1x: "Eight brand-new automatic lanes, atmospheric lighting and that one perfect strike. For families, couples and groups of friends.",
      c2t: "Packages",
      c2x: "Food + bowling = the perfect combination. From classic Flemish stew to stone grill, always with two games included.",
      c3t: "Bowl & Brunch",
      c3x: "Brunch first. Then bowling. Or the other way around. Our new weekend formula with brunch buffet and two games.",
      c4t: "(Jenever) Disco Bowling",
      c4x: "Light shows, blacklight and the best hits. The lanes turn into a dancefloor — bowl away.",
      c5t: "Pool",
      c5x: "Challenge your friends at our pool tables — the perfect break between two games.",
      c6t: "Darts",
      c6x: "Our dartboards are waiting for your sharpest throws, for beginners and competitors alike.",
      c7t: "Cocktail Bar",
      c7x: "End your evening at the bar with a fresh cocktail or a nice beer.",
      c8t: "Kids' Disco Bowling",
      c8x: "Disco bowling for the little ones: every Wednesday and Saturday before 8pm.",
      c9t: "Kids' Parties",
      c9x: "Spectacular birthday parties with bowling, fries and a gift for the birthday child.",
      link: "Discover more",
    },
    prices: {
      title: "Bowling prices",
      sub: "Fair and clear: all prices are per person, per game.",
      perPerson: "per person",
      perGame: "per game",
      r1: "Monday – Thursday before 6pm",
      r2: "Monday – Thursday from 6pm",
      r3: "Friday, Saturday, Sunday & holidays",
      r4: "Disco Bowling",
      r5: "Jenever Disco Bowling",
      r6: "School holidays Monday – Friday",
      r7: "Bowling shoes",
      note: "Prices are per person, per game. One game is a single round of bowling.",
      cta: "Book a lane",
      poolDartsTitle: "Pool & Darts prices",
      poolDartsNote: "Pool and darts are per table or per board — not per person.",
      poolGreen: "Pool · green table",
      poolGreenMeta: "per hour · counter system · per table",
      poolRed: "Pool · red table",
      poolRedMeta: "per game · coins · per table",
      dartsRow: "Darts",
      dartsMeta: "per board · per hour",
    },
    disco: {
      title: "Disco Bowling",
      sub: "Light show, blacklight & the best hits",
      text: "When the sun goes down, Helios turns into a neon paradise. Disco balls, colourful light beams and music that carries you away — bowling has never been this festive.",
      price: "€5.50",
      cta: "Book disco bowling",
    },
    arrangements: {
      title: "Packages",
      sub: "Food + bowling = the perfect combination.",
      banner: "Prices = per person",
      includes: "Included",
      perPerson: "per person",
      min8: "Minimum 8 people",
      allin: "All-in option",
      allinText: "Drinks included for 4 hours, excluding spirits and energy drinks.",
      depositTitle: "Cancellation policy",
      depositText: "No deposit is required. For cancellations made less than 48 hours in advance, €10 per person is charged.",
      cta: "Book a package",
      a1: { name: "Flemish", tag: "The classic", items: ["House aperitif", "Soup", "Assorted vegetables", "Vol-au-vent or stew", "Fries", "House dessert", "2 bowling games", "Shoes included"] },
      a2: { name: "Italian", tag: "Pasta perfetta", items: ["House aperitif", "Garlic bread", "Spaghetti bolognaise, carbonara or vegetarian pasta", "House dessert", "2 bowling games", "Shoes included"] },
      a3: { name: "Cold Buffet", tag: "For groups", items: ["House aperitif", "Cold buffet", "House dessert", "2 bowling games", "Shoes included"] },
      a4: { name: "Stone Grill", tag: "Red hot", items: ["House aperitif", "Stone grill with mixed meat and fish", "Vegetable mix", "Pasta & potato salad", "Fries & baguette", "Various sauces", "House dessert", "2 bowling games", "Shoes included"] },
    },
    brunch: {
      title: "Bowl & Brunch",
      concept: "Brunch first. Then bowling. Or the other way around.",
      text: "Our newest formula: a stylish brunch under the disco ball, followed by two games on the lanes. Weekend vibes guaranteed.",
      included: "Included",
      perPerson: "per person",
      kids02: "Kids 0–2 years: free",
      kids35: "Kids 3–5 years: €10 per child",
      cta: "Book Bowl & Brunch",
      badge: "New",
    },
    kids: {
      title: "Kids' Parties",
      sub: "A spectacular birthday party on the lanes.",
      price: "€17.50",
      perKid: "per child",
      minKids: "From 6 children",
      included: "Included",
      items: ["2 bowling games", "Shoe rental", "1 drink", "1 ice cream per child", "A fun surprise and gift for the birthday child"],
      formulas: "Formulas",
      formulaItems: ["Fries with curry sausage, cheese croquette or salad", "Spaghetti bolognaise", "Curry sausage or hamburger sandwich", "Pancakes", "Meatballs with cherries", "Pizza margherita, BBQ chicken or pepperoni (half a pizza per child)"],
      extra: "Extra bowling game",
      extraPrice: "€2.50 per game",
      discoNote: "Kids' disco bowling: every Wednesday and Saturday before 8pm.",
      cta: "Book a party",
    },
    restaurant: {
      title: "More than bowling",
      sub: "Our restaurant & café",
      text: "Not into bowling? You're still very welcome! In our restaurant you can enjoy a nice drink and a delicious meal. Our extensive menu definitely has something you'll fancy.",
      menu: "View food menu",
      drinks: "View drinks menu",
    },
    jenever: {
      title: "Jenever Disco Bowling",
      sub: "The legendary Helios tradition",
      text: "Bowling, disco and a dash of jenever cosiness. The perfect night out with friends: strikes, great vibes and the best classics through the speakers — and you can win jenever shots or other fun prizes!",
      price: "€5.50",
      note: "Every Saturday from 20:00. On Fridays (outside competition, every other week) there is disco bowling or theme bowling.",
      themeTitle: "Theme bowling on Fridays",
      themeText: "Every other week there's theme bowling on Friday. Want to know which theme is coming up? Give us a call or check our Instagram!",
      themeCall: "Call 014 81 20 93",
      themeInsta: "Instagram",
      cta: "Book jenever disco bowling",
    },
    reviews: {
      title: "What do our bowlers say?",
      viaGoogle: "Reviews via Google",
      allOnMaps: "See all reviews on Google Maps",
      items: [
        { text: "Amazing kids' party with 8 children. Bowling, pool, fries. A wonderful afternoon! Thank you Bowling Helios!", author: "Marie from Mol-Wezel" },
        { text: "Our trusted bowling alley for years. Beautiful lanes and everything perfectly arranged for a night of bowling!", author: "Steven from Balen" },
        { text: "Top location for bowling. Our youth movement had a fantastic time with disco bowling. See you next time!", author: "Matthias from Meerhout" },
      ],
    },
    hours: {
      title: "Opening hours",
      mon: "Monday",
      tue: "Tuesday",
      wed: "Wednesday",
      thu: "Thursday",
      fri: "Friday",
      sat: "Saturday",
      sun: "Sunday",
      closed: "Closed",
      groups: "Associations and schools can also book outside regular opening hours.",
      holidays: "During school holidays we are open every day — including Monday, from 11:00 to 23:00 (or until closing if the evening runs late). On public holidays that fall on a Monday we are open from 11:00 until closing.",
    },
    contact: {
      title: "Contact",
      sub: "See you in Balen",
      address: "Gerheide 48, 2490 Balen, Belgium",
      call: "Call us",
      mail: "Email us",
      route: "Plan your route",
    },
    reserve: {
      title: "Book now",
      sub: "Fill in the form and we will confirm your booking as soon as possible.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      people: "Number of people",
      date: "Date",
      time: "Approx. start time",
      type: "Reservation type",
      arrangement: "Package",
      message: "Additional information",
      types: { bowling: "Bowling", discobowling: "Disco Bowling", jenever: "Jenever Disco Bowling", arrangement: "Package", kinderfeestje: "Kids' Party", other: "Other" },
      arrOptions: { vlaams: "Flemish — €43 p.p.", italiaans: "Italian — €43 p.p.", "koud-buffet": "Cold Buffet — €52 p.p.", steengrill: "Stone Grill — €52 p.p." },
      formula: "Formula",
      formulaOptions: { frietjes: "Fries with curry sausage, cheese croquette or salad", spaghetti: "Spaghetti bolognaise", broodje: "Curry sausage or hamburger sandwich", pannenkoeken: "Pancakes", frikadellen: "Meatballs with cherries", pizza: "Pizza margherita, BBQ chicken or pepperoni (half a pizza per child)" },
      arrWarning: "Note: packages are priced per person.",
      deposit: "No deposit is required. For cancellations made less than 48 hours in advance, €10 per person is charged.",
      submit: "Send reservation",
      sending: "Sending...",
      successTitle: "Reservation received!",
      successText: "Thank you! We've received your request and will confirm your booking as soon as possible by email or phone.",
      again: "New reservation",
      error: "Something went wrong. Please try again or call us at +32 (0)14 81 20 93.",
      emailError: "Please check your email address — there seems to be a typo.",
      netError: "No response from the server. Your reservation may still have arrived — check your inbox or call us: +32 (0)14 81 20 93.",
      discoWarn1: "Jenever Disco Bowling starts every Saturday at 8pm. Every other Friday there's ",
      discoWarnLink: "disco or theme bowling",
      discoWarn2: " — call us or check Instagram to find out the theme.",
      timeError: "Please choose a round half hour, e.g. 3:00 pm or 3:30 pm.",
      fridayNewsTitle: "Theme bowling on Fridays",
      fridayNewsSub: "Every other Friday — call us or check Instagram for the theme",
      fridayNewsFrom: "from 8:00 PM",
      fridayNewsCta: "Check our Instagram",
    },
    xmas: {
      title: "Counting down to Saint Nicholas and Christmas together!",
      sub: "We celebrate the holidays together — with snow, lights and strikes!",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      seconds: "seconds",
      toSint: "until Saint Nicholas!",
      toXmas: "until Christmas!",
      merry: "Happy holidays!",
    },
    insta: {
      title: "Follow us on Instagram",
      sub: "Theme nights, vibes and deals — first on Instagram",
      follow: "Go to @bowlinghelios",
    },
    footer: {
      tagline: "Because it's more fun to bowl a strike!",
      links: "Quick links",
      contactTitle: "Contact",
      hoursTitle: "Opening hours",
      rights: "All rights reserved.",
    },
    marquee: "Disco Bowling · Packages · Kids' Parties · Jenever Disco Bowling · Restaurant · ",
    faq: {
      title: "Frequently asked questions",
      sub: "Everything you want to know about bowling, food, booking and more.",
      search: "Search the FAQ...",
      all: "All",
      noResults: "No questions found. Try a different search term or category.",
      stillTitle: "No answer found?",
      stillText: "Your question not listed? No problem! Feel free to contact us — we're happy to help and will answer as quickly as possible.",
      stillSocial: "Or send us a message via Facebook or Instagram. See you soon at Bowling Helios!",
    },
    news: {
      title: "News",
      sub: "The latest from Bowling Helios",
      n1tag: "Renewed",
      n1t: "Our bowling alley is completely renewed!",
      n1d: "14 – 22 September 2026",
      n1x: "For one week we worked hard: from 14 to 22 September 2026 our bowling alley got a complete make-over. New balls, new shoes, new machines, new displays and new ball returns — everything shines like never before.",
      n2tag: "New",
      n2t: "Stairway to Heaven — our renewed cocktail bar",
      n2d: "September 2026",
      n2x: "Under the stairs you'll now find Stairway to Heaven: our renewed cocktail bar, completely refreshed in the same week. Discover an even bigger cocktail and special drinks menu than what's on the menu card. Come and taste!",
    },
    admin: {
      title: "Helios Admin",
      login: "Log in",
      password: "Password",
      logout: "Log out",
      brunchSettings: "Bowl & Brunch settings",
      priceAdult: "Adult price (€)",
      priceKid: "Child price 3–5 years (€)",
      menuNl: "Menu items (NL — one per line)",
      menuEn: "Menu items (EN — one per line)",
      save: "Save",
      saved: "Saved!",
      reservations: "Reservations",
      noReservations: "No reservations yet.",
      loginError: "Invalid login.",
      confirm: "Confirm",
      confirmSend: "Send confirmation",
      confirmed: "Confirmed",
      notePlaceholder: "Optional message for the customer (e.g. lane 5 reserved)",
      cancel: "Cancel",
      cancelSend: "Send cancellation",
      cancelled: "Cancelled",
      reasonPlaceholder: "Reason for cancellation (emailed to the customer)",
      reopen: "Reopen",
      delete: "Delete",
      deleteConfirm: "Sure?",
      templates: "Ready-made messages",
      templatesHint: "Click copy and paste the message into your email or conversation.",
      copy: "Copy",
      copied: "Copied!",
      tpl1Name: "Confirmation",
      tpl2Name: "Fully booked",
      tpl1: "Your reservation is hereby confirmed. Any questions? Feel free to email heliosbowling@gmail.com or call +32 (0)14 81 20 93 mentioning the name of your reservation. We look forward to welcoming you!",
      tpl2: "Unfortunately all lanes are booked on this date. Feel free to call us at +32 (0)14 81 20 93 and we'll find another suitable moment together.",
      customTitle: "Your messages",
      quickFill: "Quick fill",
      addTemplate: "Add message",
      tplName: "Message name",
      tplText: "Message text",
    },
  },
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1650314200456-a19942fd1c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxib3dsaW5nJTIwYWxsZXklMjBnbG93aW5nJTIwZGlzY28lMjBuZW9uJTIwbGlnaHRzfGVufDB8fHx8MTc4OTI4Njg2NHww&ixlib=rb-4.1.0&q=85",
  pins: "https://images.unsplash.com/photo-1645394319415-5eb7e583a804?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxib3dsaW5nJTIwYWxsZXklMjBnbG93aW5nJTIwZGlzY28lMjBuZW9uJTIwbGlnaHRzfGVufDB8fHx8MTc4OTI4Njg2NHww&ixlib=rb-4.1.0&q=85",
  lanesReal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/q7rcdbmi_image.png",
  cocktails: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/wq2h2gf3_image.png",
  cocktailsBar: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/6l00we57_image.png",
  poolImg: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/yspc9hlf_image.png",
  dartsImg: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/yglh8ykn_image.png",
  desserts: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/t4mbnk8f_image.png",
  dartsReal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/mo9tl3z4_image.png",
  poolReal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/lopa5ndp_image.png",
  poolGreenImg: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/kamz5fg7_image.png",
  buffetReal: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/jdgalzw0_image.png",
  jeneverShots: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/5d5ctdt6_image.png",
  kidBall: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/7shx8d3o_image.png",
  neonSign: "https://images.unsplash.com/photo-1614908238880-6cd6796a0f51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxib3dsaW5nJTIwYWxsZXklMjBnbG93aW5nJTIwZGlzY28lMjBuZW9uJTIwbGlnaHRzfGVufDB8fHx8MTc4OTI4Njg2NHww&ixlib=rb-4.1.0&q=85",
  crowd: "/images/discobowling.png",
  food1: "/images/vlaams.png",
  food2: "/images/buffet.png",
  food3: "/images/italiaans.png",
  steengrill: "/images/steengrill.png",
  jeneverImg: "/images/jenever.png",
  kidsParty: "/images/kidsparty.png",
  kidsDisco: "/images/kidsdisco.png",
  newsBowling: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/kt2xih4d_image.png",
  newsBar: "/images/news-bar.png",
  pool: "https://images.unsplash.com/photo-1642191135995-6de2cce0bbdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxiaWxsaWFyZHMlMjBwb29sJTIwdGFibGUlMjBkYXJrJTIwYmFyJTIwYmFyfGVufDB8fHx8MTc4OTI4Njg3MHww&ixlib=rb-4.1.0&q=85",
  menuPdf: "https://customer-assets-m6fa6gv7.emergentagent.net/job_helios-entertainment/artifacts/0ln9mc5o_Menu%20Kaart%20BOWLING%20HELIOS.pdf",
  drinksPdf: "https://www.bowlinghelios.be/wp-content/uploads/2025/06/Menukaart-met-drank-1.pdf",
};

export const INSTAGRAM_POSTS = [
  "https://www.instagram.com/p/DeNJnrBuMgF/",
  "https://www.instagram.com/p/DduRQnvjiZ5/",
];

export const HOURS = [
  { day: "mon", time: null },
  { day: "tue", time: "11:00 – 23:00" },
  { day: "wed", time: "11:00 – 23:00" },
  { day: "thu", time: "11:00 – 23:00" },
  { day: "fri", time: "11:00 – 00:00" },
  { day: "sat", time: "11:00 – 00:00" },
  { day: "sun", time: "09:00 – 22:00" },
];
